<template>
  <div class="history">
    <v-base-card>
      <template v-slot:heading>
        アカウント {{title}}
      </template>
      <template v-slot:content>
        <v-account-form @submit="submit" />
      </template>
    </v-base-card>
  </div>
</template>

<script>
import VBaseCard from '@/components/molecules/BaseCard'
import VAccountForm from '@/components/organizms/AccountForm'

export default {
  components: {
    VBaseCard,
    VAccountForm
  },
  data () {
    return {
      loginId: null,
      password: null,
      selected: []
    }
  },

  computed: {
    title() {
      return this.$store.getters['account/title']
    },
  },

  mounted() {
  },
  beforeDestroy() {
    // 画面離れる時、データ初期化
    this.$store.commit('account/initialize')
  },

  methods: {
    async submit() {
      this.makeHashForSubjectTeachersAttributes()
      const res = await this.$store.dispatch('account/submit')
      this.$toasted.global.success({ message: res.message })
      this.$router.push('/admin/accounts')
    },
    // 登録用に担当教科のデータ整形
    makeHashForSubjectTeachersAttributes() {
      const subjectTeachersAttributes = []
      const subjectTeachers = this.$store.state.account.subjectTeachers
      // オブジェクトから配列に変換
      let selected = this.$store.state.account.selectedSubjects
      selected = Object.keys(selected).map(key => selected[key])
      selected = selected.concat(this.$store.state.account.selectedSubjectOptions.filter(item => item.includes('ssk')))

      selected.forEach( (item) => {
        // 学年を取得（末尾１文字のみ取得）
        const grade_id = item.slice(-1)
        // 教科コード（先頭２文字を取得）
        const subject_code = item.slice(0, 2)
        // 教科マスタから教科コードに該当する教科IDを取得する
        const subject_id = this.$store.state.master.allSubjects.find(v => v.code == subject_code).id

        // データ登録用配列にハッシュを追加する
        if (item.includes('ssk')) {
          subjectTeachersAttributes.push({
            grade_id:    2,
            subject_id:  subject_id,
            is_shingaku: true,
          })
        } else {
          subjectTeachersAttributes.push({
            grade_id:   grade_id,
            subject_id: subject_id,
          })
        }
      })

      const subjectPerGrade = this.$store.state.account.selectedSubjectOptions.reduce((acc, item) => {
        const key = item.match(/t\d+/)?.[0]; // `t1`, `t2`, `t3` を抽出
        if (key) {
          acc[key] = acc[key] || [];
          acc[key].push(item.replace(key, ''));
        }
        return acc;
      }, {});
      Object.keys(subjectPerGrade).forEach((item) => {
        const grade_id = this.$store.state.master.allGrades.find(v => v.code == item).id
        const subject_option_ids = subjectPerGrade[item].map(subjectCode => this.$store.state.master.allSubjects.find(v => v.code == subjectCode).id)
        // データ登録用配列にハッシュを追加する
        subject_option_ids.forEach((subject_option_id) => {
          // sskが含まれているかチェック
          if (item.includes('ssk')) {
            subjectTeachersAttributes.push({
              grade_id:    grade_id,
              subject_id:  subject_option_id,
              is_shingaku: true,
            })
          } else {
            subjectTeachersAttributes.push({
              grade_id:   grade_id,
              subject_id: subject_option_id,
            })
          }
        })
      })

      // 更新用に無駄なレコードを削除
      subjectTeachers.forEach((data) => {
        const index = subjectTeachersAttributes.findIndex(v =>
          v.grade_id == data.grade_id &&
          v.subject_id == data.subject_id &&
          (v.is_shingaku || false) == (data.is_shingaku || false)
        );
        if (index === -1) {
          subjectTeachersAttributes.push({
            id: data.id,
            _destroy: 1
          })
        } else {
          subjectTeachersAttributes.splice(index, 1)
         }
      })

      // 整形後、storeに格納する
      this.$store.commit('account/setSubjectTeachersAttributes', {
        subjectTeachersAttributes: subjectTeachersAttributes
      })
    },
  }
}
</script>

<style lang="stylus" scoped>

.select
  font-size: 11px !important;
</style>
